import { render, staticRenderFns } from "./question-connected.vue?vue&type=template&id=2e071b9d&scoped=true&"
import script from "./question-connected.vue?vue&type=script&lang=js&"
export * from "./question-connected.vue?vue&type=script&lang=js&"
import style0 from "./question-connected.vue?vue&type=style&index=0&id=2e071b9d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e071b9d",
  null
  
)

export default component.exports